/**
 * CustomLayout component provides a context for custom layout configurations.
 *
 * This component uses the `CustomLayoutProvider` to supply custom layout configurations
 * to its children components.
 *
 * @param {ICustomLayoutProps} props - The properties for the CustomLayout component.
 * @param {CustomLayoutConfig} [props.customLayoutConfig] - Configuration for custom layouts.
 * @param {React.ReactNode} [props.children] - The child components to be wrapped by the custom layout context.
 *
 * @returns {JSX.Element} The CustomLayout component.
 *
 * @example
 * <CustomLayout customLayoutConfig={customLayoutConfig}>
 *   <YourComponent />
 * </CustomLayout>
 */

import React from "react";
import { CustomLayoutConfig } from "./createCustomLayoutContext";
import CustomLayoutProvider from "./CustomLayoutProvider";

export interface ICustomLayoutProps {
  customLayoutConfig?: CustomLayoutConfig;
  children?: React.ReactNode;
}

const CustomLayout: React.FC<ICustomLayoutProps> = ({
  customLayoutConfig,
  children,
}) => {
  return (
    <CustomLayoutProvider customLayoutConfig={customLayoutConfig}>
      {children}
    </CustomLayoutProvider>
  );
};

export default CustomLayout;